/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homeconferenceseyebrow2Inputs */



/**
* | output |
* | --- |
* | "Conferences" |
*
* @param {Homeconferenceseyebrow2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homeconferenceseyebrow2 = /** @type {((inputs?: Homeconferenceseyebrow2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homeconferenceseyebrow2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Conferences")
	return /** @type {LocalizedString} */ ("Konferenzen")
});
export { homeconferenceseyebrow2 as "homeConferencesEyebrow" }